import http from '@/services/http';
import Endpoints from '@/services/http/endpoints';
import { ApiEndpoints } from '@/types/backend';

export default {
    getProvinces () {
        return http.get(Endpoints.get(ApiEndpoints.provinces));
    },
    getBubbles (data: any) {
        return http.get(Endpoints.get(ApiEndpoints.bubbles, { provinceId: data }));
    },
    getFamilies (data: any, filter: any, source: any) {
        return http.get(Endpoints.get(ApiEndpoints.familiesList, {
            bubbleId: data,
            ...filter,
            offset: filter.offset - 1
        }), {
            ...source
        });
    },
    getFamily (data: any) {
        return http.get(Endpoints.get(ApiEndpoints.details, {
            familyEditionId: data.familyEditionId,
            warehouseId: data.warehouseId,
            bubbleId: data.bubbleId,
            filterWarehouseId: data.filterWarehouseId,
            helpCriteriaId: data.helpCriteriaId,
            hasGreaterNeeds: data.hasGreaterNeeds
        }));
    },
    postDonor (data: any) {
        return http.post(Endpoints.get(ApiEndpoints.giftgiver, {
            familyEditionId: data.familyEditionId,
            warehouseId: data.warehouseId
        }), data.data);
    },
    getDonor (data: any) {
        return http.get(Endpoints.get(ApiEndpoints.giftgiver, data));
    },
    getConsent (): any {
        return http.get(Endpoints.get(ApiEndpoints.consent));
    },
    getGiftgiverCategories (): any {
        return http.get(Endpoints.get(ApiEndpoints.giftgiver_categories));
    },
    getResourceFilter (data: any) {
        return http.get(Endpoints.get(ApiEndpoints.filter_resource, { bubbleId: data }));
    },
    getLangs () {
        return http.get(process.env.VUE_APP_CUSTOM_LANG_URL);
    },
    getFamiliesAmount () {
        return http.get(Endpoints.get(ApiEndpoints.families_amount));
    }
};
